var SmarterPaperSharePopup = {
    keypointText: false,
    init: function () {

        this.highlightAndShare();
        this.initKeypointsShare();
    },
    initKeypointsShare: function () {
        var self = this;
        jQuery('.keypoint-share .share-links a').on('click', function (e) {
            e.preventDefault();
            var el = jQuery(this),
                keypoint = el.parents('.key-point-paragraph'),
                highlight = keypoint.find('.key-point-marker').data('highlight');

            if (e.target.className === 'icn-linkedin' || e.target.className === 'icn-email') {
                self.keypointText = SmarterPaperShareContent[highlight]['facebookAndLinkedIn'];
            } else if (e.target.className === 'icn-twitter') {
                self.keypointText = SmarterPaperShareContent[highlight]['twitter'];
            }

            self.shareKeypoint(el.attr('class'));
        });
    },
    /**
    * This listens for text highlights and opens up a share tooltip if the user has selected text.
    */
    highlightAndShare: function() {
    	var parent = this;

        jQuery('.highlight-share-enabled').on('click', function(e) {

            var target = e.target;
            if(!jQuery(target).is('a') && !jQuery(target).parent().is('a')) {
                e.preventDefault();
                var tip = jQuery('#social-media-share__tooltip'),
                    openClass = 'open',
                    selection = jQuery(this),
                    position = selection.offset();
                var tipRight = (jQuery(window).outerWidth() < 768) ? jQuery(window).outerWidth() * 0.03 : jQuery('.section-active .twocol .col').first().offset().left + jQuery('.section-active .twocol .col').first().width();
                var tipTop = (jQuery(window).outerWidth() < 768) ? e.pageY + 20 : e.pageY - 30;

                tip.css({
                    'visibility': parent.getSelectionText().length > 1 ? 'visible' : 'hidden',
                    'top': tipTop,
                    'left': tipRight,
                    'position': 'absolute'
                });

                parent.keypointText = false;
            }
        });
    },

    shareKeypoint: function (shareType) {
        if (shareType === 'icn-twitter'){
            this.openTwitterPopup();
        }
        if (shareType === 'icn-linkedin'){
            this.openLinkedInPopup();
        }
        if (shareType === 'icn-email'){
            this.openEmailClient();
        }
    },
	openEmailClient: function () {
		var url  = 'mailto:';
			url += '?subject=' + SmarterPaperShareContent.email.subject;
			url += '&body=' + this.getEmailBody();

		window.location.href = url;
    },
    getEmailBody: function () {
    	var text = SmarterPaperShareContent.email.body;

    	text = text.replace('{excerpt}', this.getSummaryText());
    	text = text.replace('{link}', SmarterPaperShareContent.shareURL);
    	return text;
    },
    openTwitterPopup: function () {
    	var url  = 'https://twitter.com/intent/tweet';
    	if (typeof shareText !== 'undefined'){

        } else {
            url += '?text=' + this.getSummaryText() + ' ' + SmarterPaperShareContent.shareURL;
        }

        this.openPopup(url);
    },
    getSummaryText: function() {

        if(this.keypointText) {
            return encodeURIComponent('"' + this.keypointText  + '"');
        }

        return encodeURIComponent('"' + this.getSelectionText()  + '"');

    },

    openLinkedInPopup: function () {
    	var url  = 'https://www.linkedin.com/shareArticle?mini=true';
    		url += '&url=' + SmarterPaperShareContent.shareURL;
    		url += '&title=' + SmarterPaperShareContent.defaultTitle;
    		url += '&summary=' + this.getSummaryText();

        this.openPopup(url);

        return false;
    },

    openPopup: function (link) {
        var
            px = Math.floor( ( (screen.availWidth || 1024) - 500 ) / 2 ),
            py = Math.floor( ( (screen.availHeight || 700) - 500 ) / 2 );

        // var popup = window.open(link, "social",
        //     "width=" + 500 + ",height=" + 500 +
        //     ",left=" + px + ",top=" + py +
        //     ",location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1");

        // full width and height new tab
        var popup = window.open(link, '_blank');

        if (popup) {
            popup.focus();
        }
    },
    getSelectionText: function () {

        var text = "";
        if (window.getSelection) {
            text = window.getSelection().toString();
        } else if (document.selection && document.selection.type != "Control") {
            text = document.selection.createRange().text;
        }
        return text;

    }
}
